import Cookies from 'universal-cookie';
import { markSessionActive, storeSessionExpiry } from './sessionState';

const cookies = new Cookies();

/** Set a cookie with the given key and value.
 * If the value is an object, it will be stringified before being set.
 * If the value is not an object, it will be set as is.
 * 
 * @param {string} key - The name of the cookie
 * @param {any} value - The value to store in the cookie
 * @param {number} minutes - The number of minutes until the cookie expires
 */
const setCookie = (key, value, minutes = 30) => {
    var dt = new Date();
    var expireOn = new Date();
    expireOn.setMinutes(dt.getMinutes() + minutes);
    // a login writes user-info and persistence-key: remember that this tab is signed in and when
    // the session ends. Always overwrite the stored expiry (never keep an older one): persistence-key
    // is also written alone (sign-up, token refresh), and a stale expiry would log out a fresh session.
    if(key === 'user-info' || key === 'persistence-key'){
        markSessionActive();
        storeSessionExpiry(minutes);
    }
    // cookies.set(key, value, { path: '/', expires: expireOn });
    if(typeof value === 'object'){
        cookies.set(key, JSON.stringify(value), { path: '/', expires: expireOn });
    }else{
        cookies.set(key, value, { path: '/', expires: expireOn });
    }
};

const removeCookie = (name) => {
    cookies.set(name, '', { path: '/', expires: new Date(Date.now()) });
};

/** Get a cookie with the given key.
 * If the cookie value is a JSON object, it will be parsed before being returned.
 * 
 * @param {string} key - The name of the cookie
 * @returns {any} The value of the cookie
 */
const getCookie = (key) => {
    const cookieValue = cookies.get(key);
    return cookieValue;
};

const getAllCookies = () => {
    return cookies.getAll();
};

export { setCookie, getCookie, removeCookie, getAllCookies };